/* eslint-disable */
import { SVGProps } from "react";
const SvgMisc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.306}
    height={17.464}
    fill="currentColor"
    viewBox="0 0 13.306 17.464"
    {...props}
  >
    <path
      data-name="Path 896"
      d="M3.742 2.495h5.821a.415.415 0 0 0 .416-.416v-.832a.416.416 0 0 0-.416-.416H8.088a1.654 1.654 0 0 0-2.87 0H3.742a.416.416 0 0 0-.416.416v.832a.416.416 0 0 0 .416.416Zm0 0"
    />
    <path
      data-name="Path 897"
      d="M3.326 9.564h.832v.832h-.832Zm0 0"
    />
    <path
      data-name="Path 898"
      d="M3.326 13.306h.832v.832h-.832Zm0 0"
    />
    <path
      data-name="Path 899"
      d="M3.326 5.821h.832v.832h-.832Zm0 0"
    />
    <path
      data-name="Path 900"
      d="M12.89 1.663h-2.079v.416a1.249 1.249 0 0 1-1.247 1.247H3.742a1.249 1.249 0 0 1-1.247-1.247v-.416H.416A.415.415 0 0 0 0 2.079v14.969a.415.415 0 0 0 .416.416H12.89a.415.415 0 0 0 .416-.416V2.079a.415.415 0 0 0-.416-.416Zm-7.9 12.89a.415.415 0 0 1-.416.416H2.911a.415.415 0 0 1-.416-.416V12.89a.415.415 0 0 1 .416-.416h1.663a.415.415 0 0 1 .416.416Zm0-3.742a.415.415 0 0 1-.416.416H2.911a.415.415 0 0 1-.416-.416V9.148a.415.415 0 0 1 .416-.416h1.663a.415.415 0 0 1 .416.416Zm0-3.742a.415.415 0 0 1-.416.416H2.911a.415.415 0 0 1-.416-.416V5.405a.415.415 0 0 1 .416-.416h1.663a.415.415 0 0 1 .416.416Zm2.911 7.9H6.237a.416.416 0 1 1 0-.832H7.9a.416.416 0 0 1 0 .832Zm2.499-1.663H6.237a.416.416 0 1 1 0-.832H10.4a.416.416 0 0 1 0 .832Zm-4.579-2.495a.416.416 0 0 1 .416-.416H7.9a.416.416 0 0 1 0 .832H6.237a.416.416 0 0 1-.416-.416ZM10.4 9.563H6.237a.416.416 0 1 1 0-.832H10.4a.416.416 0 0 1 0 .832ZM5.821 7.068a.416.416 0 0 1 .416-.416H7.9a.416.416 0 0 1 0 .832H6.237a.416.416 0 0 1-.416-.416ZM10.4 5.821H6.237a.416.416 0 1 1 0-.832H10.4a.416.416 0 0 1 0 .832Zm0 0"
    />
  </svg>
);

export default SvgMisc;
